<template>
  <b-button-group>
    <b-button
      class="mr-2"
      size="sm"
      variant="outline-success"
      @click="$emit('addGoodsSpec')"
      :disabled="disabled"
    >
      <i class="el-icon-plus" />
      {{ $l('INDEX.btn_add') || '添加' }}
    </b-button>
    <b-button
      class="mr-2"
      size="sm"
      variant="outline-danger"
      @click="$emit('batchDel')"
      :disabled="disabled"
    >
      <i class="el-icon-delete" />
      {{ $l('INDEX.btn_delete') || '删除' }}
    </b-button>
  </b-button-group>
</template>
<script>
export default {
  props: { disabled: { type: Boolean, default: false } },
}
</script>
